import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AdminIndicacionMedico } from './AdminIndicacionMedico';
import MainContent from '../../../components/mainContent/MainContent';
import { AdminIndicacionComercial } from './AdminIndicacionComercial';
import { GET_ADMIN_INDICACION_INDICACIONES } from '../../../data/graphQL/queries/AdminIndicacion/getAdminIndicacionIndicaciones';


export const AdminIndicacionDetalle = () => {
  const location = useLocation();
  const { dataRegistro, edit } = location.state;

  const permisoMedico = dataRegistro.permisoMedico === true 
                    || dataRegistro.permisoMedico === 'true'
                    || dataRegistro.permisoMedico === 1;

  const [indicaciones, setIndicaciones] = useState(null);

  const [getIndicaciones, { data: dataIndicaciones, loading: loadingIndicaciones }] = useLazyQuery(GET_ADMIN_INDICACION_INDICACIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!loadingIndicaciones)
    getIndicaciones({variables: { idIndicacionAprobacion: dataRegistro?.idIndicacionAprobacion }});
  }, []);

  useEffect(() => {
    if (!dataIndicaciones || loadingIndicaciones) return;
    setIndicaciones(dataIndicaciones.adminIndicacionIndicaciones.valorEsperado);
  }, [dataIndicaciones]);

  return (
    <MainContent
      component={permisoMedico ?
        <AdminIndicacionMedico indicaciones={indicaciones} edit={edit} />
        :
        <AdminIndicacionComercial indicaciones={indicaciones} edit={edit} />      
      }
      titulo={permisoMedico ? "Pantalla de Autorización Médica" : "Pantalla de Autorización Comercial"}
      noBackground
      tableMaxWidth />);


};